export const sendSearchData = (item)=>{
    return {type:'SEARCH_ITEM',item}
}